import { createSelector } from 'reselect';

const selectGlobalDbnSubscriptionMember = (state: any) => state.globalDbnSubscriptionMember;


export const selectGlobalDbnSubscriptionMemberCurrentItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.current);

export const selectGlobalDbnSubscriptionMemberListItems = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDbnSubscriptionMemberListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDbnSubscriptionMemberQueryItems = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.query);

export const selectGlobalDbnSubscriptionMemberCreatedItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.create);

export const selectGlobalDbnSubscriptionMemberPublishedItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.publish);

export const selectGlobalDbnSubscriptionMemberCompareItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.compare);

export const selectGlobalDbnSubscriptionMemberUpdatedItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.update);

export const selectGlobalDbnSubscriptionMemberReadItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.read);

export const selectGlobalDbnSubscriptionMemberDeletedItem = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.delete);

export const selectGlobalDbnSubscriptionMemberSearchedItems = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.search);

export const selectGlobalDbnSubscriptionMemberItemsCount = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.count);

export const selectGlobalDbnSubscriptionMemberItemsFilter = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.filter);

export const selectGlobalDbnSubscriptionMemberAccountMappingsListItems = createSelector([selectGlobalDbnSubscriptionMember], (globalDbnSubscriptionMember) => globalDbnSubscriptionMember.accountMappingslist);
